import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_JACKPOTS,
  GET_ALL_JACKPOTS_RESPONSE_SUCCESS,
  CREATE_JACKPOT,
  UPDATE_JACKPOT,
  DELETE_JACKPOT,
} from "./actionTypes"
import {
  getAllJackpotsCall,
  createJackpotCall,
  updateJackpotCall,
  deleteJackpotCall,
} from "../../helpers/repository"
import { getAllJackpots, getAllJackpotsResponseSuccess } from "./actions"
import { showErrorMessages } from "../../helpers/helpers"
import { showMessage } from "../../components/Common/Toaster"
import { apiError } from "../../store/actions"

function* attemptGetAllJackpots() {
  try {
    const response = yield call(getAllJackpotsCall)
    yield put(getAllJackpotsResponseSuccess(response.data.data))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateJackpot(action) {
  const { history } = action
  try {
    const response = yield call(createJackpotCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/promotions/jackpots")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditJackpot(action) {
  const { history, redirectTo } = action
  try {
    const response = yield call(updateJackpotCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllJackpots())
    history.push(`/promotions/jackpots`)
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeleteJackpot(action) {
  try {
    const response = yield call(deleteJackpotCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllJackpots())
  } catch (error) {
    showErrorMessages(error)
  }
}

function* JackpotsSaga() {
  yield takeEvery(GET_ALL_JACKPOTS, attemptGetAllJackpots)
  yield takeEvery(CREATE_JACKPOT, attemptCreateJackpot)
  yield takeEvery(UPDATE_JACKPOT, attemptEditJackpot)
  yield takeEvery(DELETE_JACKPOT, attemptDeleteJackpot)
}

export default JackpotsSaga
